export const SELECT_OPTIONS_ERROR = {
  required: {
    path: 'selection-required',
    message: 'Please select an option',
  },
};
